import { render } from "./DaftarKonten.vue?vue&type=template&id=b44e2e34"
import script from "./DaftarKonten.vue?vue&type=script&lang=js"
export * from "./DaftarKonten.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__